import { useUserEventLogger } from '@repo/tracking-service';
import { List, SubTitle, Svg } from '@repo/ui';
import { useRouter } from 'next/router';

import s from './menu.module.scss';

import { MY_PAGE_PATHS } from '@/lib/constants/paths';

export const InfoSection = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goTermsPage = () => {
    sendClickEvent('more_body_terms');

    router.push(MY_PAGE_PATHS.약관및정책);
  };

  return (
    <li>
      <SubTitle title={'정보'} size={'medium'} className={s.menu_list_padding} />

      <ul>
        <li className={s.menu_list_padding}>
          <List
            title={'약관 및 정책'}
            leadingElement={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/fill-report-bl-rg.svg`} alt="약관" width={32} height={32} />}
            supportingElement={<Svg src={'ic_chevron-right.svg'} width={20} height={20} color={'#8A96A3'} />}
            primaryAction={true}
            onClick={goTermsPage}
          />
        </li>
      </ul>
    </li>
  );
};
